import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";
import Zoom from 'react-reveal/Zoom';




class MotDuPresident extends Component {
  render() {
    return (
    <div>   
    <section className="inner-intro bg-image overlay-dark parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/germe.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Green Agro Business</a>/<span>Mot du président</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content">
                
                    <div className="col-md-8">
                     <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/> Mot du Président</h3>
                      <img src="/assets/img/images/Robert.jpg" className="president"/>
                      <Zoom bottom cascade>
                        <p className="chers one_p">Chers visiteurs, partenaires, clients, </p>
                        </Zoom>
                        <Zoom bottom cascade>
                        <p className="paragraph one_p">Nous sommes particulièrement heureux de vous accueillir sur le site internet de <b className="keywords">Green Agro Business</b>, canal idéal pour découvrir nos produits et services, et  favoriser une relation d’échange perpétuel et constructif avec vous.</p>
                          </Zoom>
                          <Zoom bottom cascade>
                         <p className="paragraph"><b className="keywords">Green Agro Business</b> s’est donné comme mission, de produire et de commercialiser au Sénégal, des solutions innovantes et respectueuses de l’environnement, afin de régénérer les sols et fertiliser les cultures de manière saine et durable.</p>
                         </Zoom>
                         <blockquote>
                          <p className="paragraph">L’engrais organique doit être accessible au plus grand nombre, permettant ainsi de limiter les coûteuses importations nationales. L’utilisation massive des pesticides et des engrais chimiques fragilise en effet l’équilibre naturel des sols. </p>
                           <p className="paragraph">Face à ce constat, <b className="keywords">Green Agro Business</b> développe sa stratégie agricole, visant à la préservation de la qualité des sols tout en maintenant une bonne productivité. C’est la raison pour laquelle nous œuvrons chaque jour pour étendre notre savoir-faire et demeurer un des acteurs majeurs sur la scène nationale et internationale.</p>
                            <p className="paragraph">Notre signature <b className="keywords">« l’agriculture par nature »</b> reflète notre engagement et notre passion à produire et à distribuer des produits <b className="keywords">100% bio</b>.</p>
                            <p className="paragraph">Cette initiative unique au Sénégal a ainsi pour double objectif, la valorisation des déchets organiques en engrais organiques et la promotion d’énergie verte dans la région de Thiès au Sénégal</p>
                            <p className="paragraph">Je voudrais pour finir, vous assurer de notre engagement et de notre détermination à tout entreprendre, dans <b className="keywords">une démarche de qualité de service et d’innovation</b>, afin de mieux vous servir et vous accompagner. </p>
                            <p className="paragraph">Je vous remercie et vous souhaite une bonne navigation sur notre site !</p>

                            </blockquote>
                            <div className="speech">
                            <b>Robert SENE,</b><br/>
                            <p><b className="status_presi"> Président Directeur Général.</b></p>
                            </div>
                    </div>
                    <Sidebar/>
                </div>
            
            </div>
        </section>
        <hr/>
    </div>
    )
  }
}
export default MotDuPresident;


// WEBPACK FOOTER //
// ./src/components/mot.jsx